import InvoiceListProcessingAction from './invoiceList-processing-action.vue';
export default InvoiceListProcessingAction;
